import { ServicesReturn, ServiceType } from '../types';
import { axiosInstance } from './base';

export const fetchServices = async () => {
  // console.log('fetchServices called');

  const { data } = await axiosInstance.get<ServicesReturn>('/services');

  return data.content;
};

export const createService = async (newService: ServiceType) => {
  console.log('createService called');
  const { data } = await axiosInstance.post<ServicesReturn>(
    '/services',
    newService
  );

  // console.log('updated data after creation:', data);

  return data.content;
};

export const deleteService = async (id: string) => {
  console.log('deleteService called');

  const { data } = await axiosInstance.delete<ServicesReturn>(
    `/services/${id}`
  );

  // console.log('updated data after deletion:', data);

  return data.content;
};

export const updateService = async (updatedService: ServiceType) => {
  console.log('updateService called');

  const { data: updatedData } = await axiosInstance.put<ServicesReturn>(
    `/services/${updatedService.id}`,
    updatedService
  );

  // console.log('updated data:', updatedData);

  return updatedData.content;
};

export const updateCategory = async (payload: {
  oldCategory: string;
  newCategory: string;
}) => {
  // console.log('updateCategory called');

  const { data: updatedData } = await axiosInstance.put<ServicesReturn>(
    '/categories',
    {
      ...payload,
    }
  );

  // console.log('updated data:', updatedData);

  return updatedData.content;
};
